import DownArrowIcon from "@/assets/svgs/down-arrow-icon";
import { Pressable, ScrollView, Text } from "react-native";
import { useSlot, useStyled } from "use-styled";
import { Tag } from "./tag";

const SelectRoot = useStyled(Pressable, {
  base: {
    className:
      "flex-1 flex-row items-center justify-between border border-gray-200 bg-teachLoop-creamLight rounded-[17] focus:outline-teal-600 disabled:opacity-50",
  },
  variants: {
    size: {
      md: { className: "px-4 py-3" },
    },
    error: {
      true: { className: "border-red-500" },
      false: {},
    },
    disabled: {
      true: { className: "opacity-50" },
    },
  },
  defaultVariants: {
    size: "md",
  },
  compoundVariants: [
    {
      disabled: true,
      props: {
        disabled: true,
      },
    },
  ],
});

const SelectLabel = useStyled(Text, {
  base: {
    className: "text-teachLoop-textPrimary font-geologica-regular",
  },
  variants: {
    size: {
      md: { className: "text-base leading-[1.5]" },
    },
  },
  defaultVariants: {
    size: "md",
  },
});

const SelectDownArrow = useStyled(DownArrowIcon, {
  base: {
    className: "h-5 w-5",
    pathClassName: "fill-teachLoop-textPrimary",
  },
  variants: {},
  defaultVariants: {},
});

function SelectResults({
  selectedOptions,
  onRemove,
}: {
  selectedOptions: { label: string; value: string | number }[];
  onRemove: (value: string | number) => void;
}) {
  if (selectedOptions.length === 0) {
    return null;
  }

  return (
    <ScrollView
      horizontal
      contentContainerClassName="gap-4"
      className="flex-grow-0"
      showsHorizontalScrollIndicator={false}
    >
      {selectedOptions.map((option) => (
        <Tag size="md" key={option.value} close>
          <Tag.Text size="md">{option.label}</Tag.Text>
          <Tag.Close
            onPress={() => {
              onRemove(option.value);
            }}
          />
        </Tag>
      ))}
    </ScrollView>
  );
}

export const Select = useSlot(SelectRoot, {
  Label: SelectLabel,
  DownArrow: SelectDownArrow,
  Results: SelectResults,
});
